const createHtml = (inner: string) => `
  <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Verizon 5G Ready</title>
  <style type='text/css'>
    html, body {
      height: 100%;
      width: 100%;
      margin: 0;
      background-color: #000;
    }
    .vdb_player {
      height: 100%;
      width: 100%;
    }
  </style>
</head>
<body>
  ${inner}
</body>
</html>
`

export const livestreamSource = createHtml(
  `<!-- TAG START { player: "5G Ready", owner: "Verizon Corp Live", for: "Verizon Corp Live" } --><div id="5fb6b39777fda725f9413dfe" class="vdb_player vdb_5fb6b39777fda725f9413dfe58de93b5134aa106074ebf91"  >    <script type="text/javascript" src="https://delivery.vidible.tv/jsonp/pid=5fb6b39777fda725f9413dfe/58de93b5134aa106074ebf91.js?"></script></div><!-- TAG END { date: 11/19/20 } -->`
)
